/**
 * Kundeportalen Orchestration Api
 * 1.0.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "@oazapfts/runtime";
import * as QS from "@oazapfts/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type StandaloneRequest = {
    principalAmount?: number;
    maturityInYears?: number;
    interestPaymentFrequency?: PaymentFreqEnum;
    loanProduct?: ContractLoanTypeEnum;
    amortizationProfile?: AmortizationProfile;
    fixedInterestPeriod?: FixedInterestPeriodType;
    fixedInterestYears?: number | null;
};
export type AmortListResponse = {
    valueDate?: string | null;
    dueDate?: string | null;
    repayment?: number | null;
    interest?: number | null;
    margin?: number | null;
    additionalPayment?: number | null;
    payment?: number | null;
    notionalAmount?: number | null;
    notifiedDate?: string | null;
    knownInterest?: boolean | null;
    interestRateStatus?: InterestRateStatus;
};
export type TimeMeasure = {
    years?: number | null;
    months?: number | null;
    days?: number | null;
};
export type CalculationInfoResponse = {
    contractId?: string | null;
    companyId?: string | null;
    companyLasId?: string | null;
    principalAmount?: number | null;
    startDate?: string | null;
    loanPurpose?: string | null;
    industryCode?: string | null;
    notionalAmount?: number | null;
    maturityDate?: string | null;
    loanProduct?: ContractLoanTypeEnum;
    sustainableFramework?: SustainableFrameworkType;
    greenLoan?: boolean | null;
    currency?: CurrencyCode;
    redemptionValue?: number | null;
    interestRate?: number | null;
    nextFixingDate?: string | null;
    latestFixingDate?: string | null;
    interestPaymentFrequency?: PaymentFreqEnum;
    amortizationProfile?: AmortizationProfile;
    spread?: number | null;
    fundingSpread?: number | null;
    agreementDate?: string | null;
    interestConditionExpiryDate?: string | null;
    firstInterestDate?: string | null;
    lastInterestDate?: string | null;
    firstInterestDueDate?: string | null;
    lastInterestDueDate?: string | null;
    amortList?: AmortListResponse[] | null;
    timeToMaturity?: TimeMeasure;
    accountingAreaId?: string | null;
    accountingGroupId?: string | null;
    instrumentId?: string | null;
    customerSwap?: string | null;
    marginRate?: number | null;
    numberOfPayments?: number | null;
    interestRatePlusSpread?: number | null;
    firstRepayDateUnadjusted?: string | null;
    firstRepayValueDate?: string | null;
    paymentConvention?: AdjustedUnadjustedEnum;
    dayCountConventions?: DayCountConventions;
    paymentAdviseType?: PaymentAdviseTypes;
    ean?: string | null;
    pbs?: string | null;
    firstPayment?: number | null;
    businessDayConvention?: BusinessDayConventionEnum;
    loanDuration?: TimeMeasure;
    payoutDate?: string | null;
    eventDescription?: EventDescriptionCode;
    repayAmount?: number | null;
    eventDueDate?: string | null;
    eventValueDate?: string | null;
    changeMethod?: ChangeMethodCode;
    calculationDateTime?: string | null;
    notionalAmountOnValueDate?: number | null;
    accruedInterest?: number | null;
    compensationAmount?: number | null;
    compensationAmountCalculated?: number | null;
    compensationAmountReported?: number | null;
    preEventMaturityDate?: string | null;
    postEventMaturityDate?: string | null;
    paymentReduction?: number | null;
    isOnTerm?: boolean | null;
    timeToMaturityReduction?: TimeMeasure;
    markedDataDateTime?: string | null;
    firstInstalmentFreeRepaymentDate?: string | null;
    calculationPath?: string | null;
    initialCosts?: number | null;
    loanDurationYearsRounded?: number | null;
    budgetSecurity?: BudgetSecurity;
    fixedInterestYears?: number | null;
    fixedInterestPeriodType?: FixedInterestPeriodType;
    scrap?: number | null;
    fixedFirstPayment?: number | null;
    averageDuration?: number | null;
    installmentFreeTerms?: number | null;
    effectiveInterestRate?: number | null;
};
export type PaymentContractSpec = {
    contract?: string | null;
    subContractNo?: number | null;
    subContractType?: SubContractTypeEnum;
    interestPayment?: string | null;
    fundedByContract?: string | null;
    fundedBySubContractNo?: number | null;
    index?: string | null;
    accountingIndex?: number | null;
    interestConvensionAdjustment?: string | null;
    businessDayConvension?: string | null;
    subContractFixingType?: SubContractFixingTypeEnum;
    interestConvension?: InterestConvensionEnum;
    dayCountConvention?: DayCountConventions;
};
export type PaymentProperties = {
    loadedDate?: string | null;
    paymentCategory?: string | null;
    paymentType?: InterestDetailedPaymentType;
    readingDate?: string | null;
    transactionDate?: string | null;
    referenceInterest?: string | null;
    referenceInterestStart?: string | null;
    referenceInterestEnd?: string | null;
    meansOfPayment?: string | null;
    bankAccount?: string | null;
    accountingDate?: string | null;
};
export type AbsolutePayment = {
    subContractNo?: number | null;
    dueDate?: string | null;
    valueDate?: string | null;
    nominalAmount?: number | null;
    netAmount?: number | null;
    remainingDebt?: number | null;
    discountFactor?: number | null;
    isLocked?: boolean | null;
    notifiedDate?: string | null;
    modificationState?: ModificationStateEnum;
    paymentProperties?: PaymentProperties;
    alternativeOrder?: number | null;
};
export type SubContract = {
    paymentContractSpecDict?: {
        [key: string]: PaymentContractSpec;
    } | null;
    cashflows?: AbsolutePayment[] | null;
    contract?: string | null;
    subContractType?: SubContractTypeEnum;
    principalAmount?: number | null;
    interestType?: string | null;
    subContractFixingType?: SubContractFixingTypeEnum;
    datesPaymentFreq?: PaymentFreqEnum;
    marketId?: string | null;
    commitDays?: number | null;
    isPrepaid?: boolean | null;
    currencyCode?: CurrencyCode;
};
export type DiscountFactor = {
    date?: string | null;
    value?: number | null;
};
export type EventPricing = {
    ZeroCouponCurve?: DiscountFactor[] | null;
    SpreadCurve?: DiscountFactor[] | null;
    TenorCurve?: DiscountFactor[] | null;
    DiscountCurve?: DiscountFactor[] | null;
    DiscountCurveClean?: DiscountFactor[] | null;
};
export type Compensation = {
    _calculationTime?: string | null;
    _npv?: number | null;
    _calculatedAmountPV?: number | null;
    _calculatedAmountFV?: number | null;
    _reportingTime?: string | null;
    _reportedAmount?: number | null;
};
export type FullRepaymentEvent = {
    asOfDate?: string | null;
    df?: number | null;
    eventDescription?: EventDescriptionCode;
    eventPricing?: EventPricing;
    compensation?: Compensation;
    startDate?: string | null;
    changeMethod?: ChangeMethodCode;
};
export type HolidayCalendar = {
    calendarId?: string[] | null;
    holidayDates?: string[] | null;
};
export type PricingData2 = {
    DKK_DKKSWAP?: DiscountFactor[] | null;
    INDFRI_KKVAR3M?: DiscountFactor[] | null;
    INDFRI_KKVAR6M?: DiscountFactor[] | null;
    INDFRI_KKVAR1Y?: DiscountFactor[] | null;
    KKVAR3M?: DiscountFactor[] | null;
    KKVAR6M?: DiscountFactor[] | null;
    KKVAR1Y?: DiscountFactor[] | null;
    INDFRI_KKCIB_MAX5Y?: DiscountFactor[] | null;
    INDFRI_KKCIB_MIN6Y?: DiscountFactor[] | null;
    KKCIBOR_MAX5Y_PRIS?: DiscountFactor[] | null;
    KKCIBOR_MIN6Y_PRIS?: DiscountFactor[] | null;
    KKFAST_MAX5Y_PRIS?: DiscountFactor[] | null;
    KKFAST_MIN6Y_PRIS?: DiscountFactor[] | null;
    INDFRI_KKFAST_MAX5Y?: DiscountFactor[] | null;
    INDFRI_KKFAST_MIN6Y?: DiscountFactor[] | null;
    TDKK3M6M?: DiscountFactor[] | null;
    TDKK6M12M?: DiscountFactor[] | null;
    TDKK1Y6M?: DiscountFactor[] | null;
    INFRBAS?: DiscountFactor[] | null;
    IBASIS3M?: DiscountFactor[] | null;
    IBASIS6M?: DiscountFactor[] | null;
    IBASIS1Y?: DiscountFactor[] | null;
    FUNDINGSPREAD_PREMIUM?: DiscountFactor[] | null;
    NotInUse?: DiscountFactor[] | null;
    DKK_LAANEASK?: DiscountFactor[] | null;
    L3M6MBID?: DiscountFactor[] | null;
    DKK_LAANEMID_Cash?: DiscountFactor[] | null;
    Zero?: DiscountFactor[] | null;
    DKK_CIBOR?: DiscountFactor[] | null;
    KKVAR1M?: DiscountFactor[] | null;
};
export type MdaCiborCurveRates = {
    DKK_DKKSWAP?: number[] | null;
    INDFRI_KKVAR3M?: number[] | null;
    INDFRI_KKVAR6M?: number[] | null;
    INDFRI_KKVAR1Y?: number[] | null;
    KKVAR3M?: number[] | null;
    KKVAR6M?: number[] | null;
    KKVAR1Y?: number[] | null;
    INDFRI_KKCIB_MAX5Y?: number[] | null;
    INDFRI_KKCIB_MIN6Y?: number[] | null;
    KKCIBOR_MAX5Y_PRIS?: number[] | null;
    KKCIBOR_MIN6Y_PRIS?: number[] | null;
    KKFAST_MAX5Y_PRIS?: number[] | null;
    KKFAST_MIN6Y_PRIS?: number[] | null;
    INDFRI_KKFAST_MAX5Y?: number[] | null;
    INDFRI_KKFAST_MIN6Y?: number[] | null;
    TDKK3M6M?: number[] | null;
    TDKK6M12M?: number[] | null;
    TDKK1Y6M?: number[] | null;
    INFRBAS?: number[] | null;
    IBASIS3M?: number[] | null;
    IBASIS6M?: number[] | null;
    IBASIS1Y?: number[] | null;
    FUNDINGSPREAD_PREMIUM?: number[] | null;
    NotInUse?: number[] | null;
    DKK_LAANEASK?: number[] | null;
    L3M6MBID?: number[] | null;
    DKK_LAANEMID_Cash?: number[] | null;
    Zero?: number[] | null;
    DKK_CIBOR?: number[] | null;
    KKVAR1M?: number[] | null;
};
export type MdaRateInformation = {
    cibor1MPureRate?: number | null;
    cibor3MPureRate?: number | null;
    cibor6MPureRate?: number | null;
    cibor12MPureRate?: number | null;
    kkVar1MSpread?: number | null;
    kkVar3MSpread?: number | null;
    kkVar6MSpread?: number | null;
    kkVar12MSpread?: number | null;
    mdaCiborCurveRates?: MdaCiborCurveRates;
};
export type PricingCollection = {
    dataReadDateTime?: string | null;
    pricingData?: PricingData2;
    mdaRateInformation?: MdaRateInformation;
};
export type InterestRates = {
    interestReferenceId?: InterestReferenceIdEnum;
    fromDate?: string | null;
    interestRate?: number | null;
};
export type BasicLoan = {
    originalLoan?: BasicLoan;
    contractType?: ContractTypeEnum;
    lendingSubContract?: SubContract;
    loanEvents?: FullRepaymentEvent[] | null;
    holidayCalendar?: HolidayCalendar;
    pricing?: PricingCollection;
    companyId?: string | null;
    companyNo?: string | null;
    companyName?: string | null;
    contractId?: string | null;
    contractGroup?: ContractGroupEnum;
    accountingGroup?: string | null;
    startDate?: string | null;
    renegotiationDate?: string | null;
    maturityDate?: string | null;
    loanObjective?: string | null;
    industryCode?: string | null;
    greenLoan?: string | null;
    contractLoanType?: ContractLoanTypeEnum;
    contractStatus?: ContractStatus;
    panoramaId?: string | null;
    agreementDate?: string | null;
    createDate?: string | null;
    accountingAreaId?: string | null;
    accountingGroupId?: string | null;
    customerSwap?: string | null;
    redemptionCalculationMethod?: RedemptionCalculationMethod;
    interestCreditRates?: InterestRates[] | null;
    ean?: string | null;
    pbs?: string | null;
    paymentAdviseType?: PaymentAdviseTypes;
};
export type NewBasicLoan = {
    originalLoan?: BasicLoan;
    contractType?: ContractTypeEnum;
    lendingSubContract?: SubContract;
    loanEvents?: FullRepaymentEvent[] | null;
    holidayCalendar?: HolidayCalendar;
    pricing?: PricingCollection;
    companyId?: string | null;
    companyNo?: string | null;
    companyName?: string | null;
    contractId?: string | null;
    contractGroup?: ContractGroupEnum;
    accountingGroup?: string | null;
    startDate?: string | null;
    renegotiationDate?: string | null;
    maturityDate?: string | null;
    loanObjective?: string | null;
    industryCode?: string | null;
    greenLoan?: string | null;
    contractLoanType?: ContractLoanTypeEnum;
    contractStatus?: ContractStatus;
    panoramaId?: string | null;
    agreementDate?: string | null;
    createDate?: string | null;
    accountingAreaId?: string | null;
    accountingGroupId?: string | null;
    customerSwap?: string | null;
    redemptionCalculationMethod?: RedemptionCalculationMethod;
    interestCreditRates?: InterestRates[] | null;
    ean?: string | null;
    pbs?: string | null;
    paymentAdviseType?: PaymentAdviseTypes;
};
export type InterestSheetCalculation = {
    baseContract?: NewBasicLoan;
    contractLoanType: ContractLoanTypeEnum;
    amortizationProfile: AmortizationProfile;
    paymentFreq: PaymentFreqEnum;
    yearsToMaturity?: number;
    yearsWithFixedRate?: number;
    interest?: number | null;
    spread?: number | null;
};
export type InterestSheetPricing = {
    contractLoanType: ContractLoanTypeEnum;
    interestConvension: InterestConvensionEnum;
    paymentFreq: PaymentFreqEnum;
    interestRate?: number;
    kkSpread?: number | null;
    isLeasing?: boolean | null;
};
export type InterestSheetResponse = {
    interestSheetCalculations?: InterestSheetCalculation[] | null;
    interestSheetPricings?: InterestSheetPricing[] | null;
    baseCalculationTime: string;
    calculationTime: string;
};
export type ValidationErrorResponse = {
    validationErrors?: string[] | null;
};
export type CompanyContact = {
    id?: string | null;
    fullname?: string | null;
    firstName?: string | null;
    lastname?: string | null;
    jobTitle?: string | null;
    email?: string | null;
    displayPhone?: string | null;
};
export type CompanyResponsible = {
    fullname?: string | null;
    displayPhone?: string | null;
};
export type CompanyInfoResponse = {
    companyName?: string | null;
    companyNumber?: string | null;
    cvr?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    typeOfLiability?: string | null;
    companyContact?: CompanyContact;
    companyResponsible?: CompanyResponsible;
};
export type CompanyGuarantor = {
    legalName?: string | null;
};
export type WzDocumentInfo = {
    recordId?: string | null;
    title?: string | null;
    recordExtension?: string | null;
    createDate?: string | null;
    recordSize?: number | null;
};
export type ProblemDetails = {
    "type"?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: any;
};
export type ServiceMessage = {
    title: string | null;
    message: string | null;
    closeable?: boolean;
};
export type MitKkFrontEndApplicationConfig = {
    loanProducts: string[];
    serviceMessage?: ServiceMessage;
};
export type OwnContractSignerStatus = {
    name: string | null;
    idpType: IdpTypes;
    email: string | null;
    toBeSigned: boolean;
    signedDate?: string | null;
};
export type GuarantorSignerStatus = {
    guarantorName: string | null;
    successfulSignatures: number;
    totalRequiredSignatures: number;
};
export type ByLawDto = {
    title: string | null;
    created: string;
    size: number;
};
export type DocumentStatus = {
    eventDescription: EventDescriptionCode;
    loanProduct?: ContractLoanTypeEnum;
    contractId: number;
    legalName?: string | null;
    deadline: string;
    nextNotification?: string | null;
    payoutDate?: string | null;
    agreementDate: string;
    signers: OwnContractSignerStatus[] | null;
    guarantorSigners?: GuarantorSignerStatus[] | null;
    byLaw?: ByLawDto;
    interestConditionStartDate?: string | null;
};
export type DocumentInfo = {
    documentId: string;
    caseId: string;
    contractId?: number;
    cvr?: number;
    title: string;
    fileSize?: number;
    eventDescription: EventDescriptionCode;
    legalName: string;
    active?: boolean;
    toBeSigned?: boolean;
    userIsSigner?: boolean;
    userHasSigned?: boolean;
    documentSigningRelation: DocumentSigningRelation;
    documentType: DocumentType;
    nextReminder?: string | null;
    deadline: string;
    createdDate: string;
    payoutDate?: string | null;
};
export type AllDocumentInfos = {
    ownDocuments?: DocumentInfo[] | null;
    guarantorDocuments?: DocumentInfo[] | null;
};
export type DocumentDatesError = {
    code?: string | null;
    message?: string | null;
    actualCount?: number | null;
    maxCount?: number | null;
    traceId?: string | null;
};
export type SignerDto = {
    idpId: string;
    documentSigningRelation: DocumentSigningRelation;
    documentType: DocumentType;
    signAsCvr?: number;
    toBeSigned?: boolean;
    signedDate?: string | null;
};
export type DocumentSignersResponse = {
    ownSigners: SignerDto[];
    guarantorSigners: SignerDto[];
};
export type SignModel = {
    script?: string | null;
    iFrameSrcUri?: string | null;
};
export type CreateCalculationDocumentRequest = {
    calculationPath: string;
    fileExtension: FileExtensionEnum;
};
export type CreateContractDocumentRequest = {
    contractId: string;
    loanProduct: ContractLoanTypeEnum;
    fileExtension: FileExtensionEnum;
    fromYear?: number | null;
    toYear?: number | null;
};
export type CreateCalculationDocumentsRequest = {
    calculationPaths: string[];
    fileExtension: FileExtensionEnum;
};
export type DownloadStoredDocumentRequest = {
    pathToStorage: string;
};
export type UserDto = {
    idpId: string;
    name: string;
    email?: string | null;
    cvr?: number;
    idpType?: IdpTypes;
    roles: Roles[];
    emailVerified?: boolean;
    [key: string]: any;
};
export type KnownUser = {
    idpId: string;
    idpType?: IdpTypes;
    name: string;
    email: string;
    roles: Roles[];
    [key: string]: any;
};
export type UnknownUser = {
    idpId: string;
    idpType?: IdpTypes;
    roles: Roles[];
    [key: string]: any;
};
export type CompanyUsers = {
    knownUsers: KnownUser[];
    unknownUsers: UnknownUser[];
    [key: string]: any;
};
export type SetEmailRequest = {
    email: string;
    [key: string]: any;
};
export type RemainingDebtInfo = {
    notionalAmount?: number;
    creditMax?: number | null;
    contractCount?: number;
};
export type AllRemainingDebtInfos = {
    asOfDate?: string;
    loans?: RemainingDebtInfo;
    subsidizedLoans?: RemainingDebtInfo;
    constructionCredits?: RemainingDebtInfo;
};
export type LoanPageInfo = {
    contractId?: string | null;
    principalAmpount?: number | null;
    notionalAmount?: number | null;
    payoutDate?: string | null;
    maturitydate?: string | null;
    industryCode?: string | null;
    greenLoan?: boolean | null;
    loanProduct?: ContractLoanTypeEnum;
    currency?: CurrencyCode;
    redemptionValue?: number | null;
    agreementDate?: string | null;
    timeToMaturity?: TimeMeasure;
    loanPurpose?: string | null;
    sustainableFramework?: SustainableFrameworkType;
    interestRate?: number | null;
    latestFixingDate?: string | null;
    amortizationProfile?: AmortizationProfile;
    nextFixingDate?: string | null;
    interestPaymentFrequency?: PaymentFreqEnum;
    interestConditionExpiryDate?: string | null;
    spread?: number | null;
    customerSwap?: string | null;
    amortList?: AmortListResponse[] | null;
};
export type PostingListResponse = {
    notifiedDate?: string | null;
    valueDate?: string | null;
    paymentTypeString?: string | null;
    paymentAmount?: number | null;
    creditAmount?: number | null;
};
export type CreditLoanPageInfo = {
    principalAmount?: number | null;
    notionalAmount?: number | null;
    disposableAmount?: number | null;
    availableAmount?: number | null;
    interestRate?: number | null;
    nextFixingDateString?: string | null;
    currency?: CurrencyCode;
    amortizationProfile?: AmortizationProfile;
    interestPaymentFrequency?: PaymentFreqEnum;
    accruedInterest?: number | null;
    loanPurpose?: string | null;
    loanProduct?: ContractLoanTypeEnum;
    industryCode?: string | null;
    agreementDate?: string | null;
    startDate?: string | null;
    maturityDate?: string | null;
    timeToMaturity?: TimeMeasure;
    redemptionValue?: number | null;
    postings?: PostingListResponse[] | null;
};
export type AmortRecord = {
    paymentDate?: string | null;
    dueDate?: string | null;
    principal?: number | null;
    repayment?: number | null;
    interestPayment?: number | null;
    marginPayment?: number | null;
    extraOrdinaryRepayment?: number | null;
    payment?: number | null;
    remainingDebt?: number | null;
    notifiedDate?: string | null;
    knownInterest?: boolean | null;
};
export type PortfolioInfo = {
    contractId?: string | null;
    companyId?: string | null;
    companyLasId?: string | null;
    principalAmount?: number | null;
    startDate?: string | null;
    loanPurpose?: string | null;
    industryCode?: string | null;
    notionalAmount?: number | null;
    maturityDate?: string | null;
    loanProduct?: ContractLoanTypeEnum;
    sustainableFramework?: SustainableFrameworkType;
    greenLoan?: boolean | null;
    currency?: CurrencyCode;
    redemptionValue?: number | null;
    interestRate?: number | null;
    nextFixingDate?: string | null;
    latestFixingDate?: string | null;
    interestPaymentFrequency?: PaymentFreqEnum;
    amortizationProfile?: AmortizationProfile;
    spread?: number | null;
    fundingSpread?: number | null;
    agreementDate?: string | null;
    interestConditionExpiryDate?: string | null;
    firstInterestDate?: string | null;
    lastInterestDate?: string | null;
    firstInterestDueDate?: string | null;
    lastInterestDueDate?: string | null;
    amortRecordList?: AmortRecord[] | null;
    timeToMaturity?: TimeMeasure;
    accountingAreaId?: string | null;
    accoutingGroupId?: string | null;
    instrumentId?: string | null;
    customerSwap?: string | null;
    firstPayment?: number | null;
    loanDuration?: TimeMeasure;
    marginRate?: number | null;
    numberOfPayments?: number | null;
    interestRatePlusSpread?: number | null;
    firstRepayDateUnadjusted?: string | null;
    paymentConvention?: AdjustedUnadjustedEnum;
    dayCountConventions?: DayCountConventions;
    paymentAdviseType?: PaymentAdviseTypes;
    ean?: string | null;
    pbs?: string | null;
    businessDayConvention?: BusinessDayConventionEnum;
    loanCategory?: LoanCategory;
    nextValueDate?: string | null;
    nonAccruedInterest?: number | null;
    disposableAmount?: number | null;
    interestType?: InterestType;
    bossInfoId?: string | null;
    bossInfoProjectName?: string | null;
    swaps?: string | null;
    swapRelatedContractId?: string | null;
    relation?: Relation;
    legalName?: string | null;
    asOfDate?: string | null;
    liabilityPct?: number | null;
    liabilityAmountDkk?: number | null;
    liabilityType?: LiabilityType;
};
export type PortfolioInfoResponse = {
    asOfDate?: string | null;
    ownerPortfolio?: PortfolioInfo[] | null;
    guaranteePortfolio?: PortfolioInfo[] | null;
    partnershipLiabilityPortfolio?: PortfolioInfo[] | null;
    billReceiverPortfolio?: PortfolioInfo[] | null;
};
export type GuarantorLiability = {
    companyId?: string | null;
    companyName?: string | null;
    liabilityPercentage?: number;
    liabilityAmount?: number;
    guaranteeRelation?: GuaranteeRelations;
};
export type LoanDocument = {
    id?: string | null;
    contractNumber?: string | null;
    companyLegalName?: string | null;
    companyLegalNameNormalized?: string | null;
    companyId?: string | null;
    companyNumber?: string | null;
    cvr?: string | null;
    startDate?: string | null;
    maturityDate?: string | null;
    principalAmountLCY?: number | null;
    principalAmountCCY?: string | null;
    notionalAmountLCY?: number | null;
    loanType?: string | null;
    isGreenLoan?: boolean | null;
    loanStatus?: string | null;
};
export type CompanyDocument = {
    id?: string | null;
    primaryContactId?: string | null;
    primaryContactName?: string | null;
    companyResponsibleId?: string | null;
    companyResponsibleName?: string | null;
    legalName?: string | null;
    legalNameNormalized?: string | null;
    companyNumber?: string | null;
    cvr?: string | null;
    expiryDateKYC?: string | null;
    status?: string | null;
    companyLASId?: string | null;
};
export type CaseDocument = {
    caseId?: string | null;
    primaryPartyName?: string | null;
    primaryPartyNameNormalized?: string | null;
    primaryPartyCVR?: string | null;
    primaryPartyCrmGuid?: string | null;
    primaryPartyContactName?: string | null;
    contractId?: string | null;
    title?: string | null;
    createDate?: string | null;
    closeDate?: string | null;
    updatedDate?: string | null;
    caseHandlerName?: string | null;
    eventDescription?: string | null;
    caseStateDescription?: string | null;
    fileClassCode?: string | null;
    casePhaseCode?: string | null;
    executingOrgUnitCode?: string | null;
    closeReasonCode?: string | null;
    closeReasonDescription?: string | null;
};
export type SearchResponse = {
    loanCount?: number | null;
    companyCount?: number | null;
    caseCount?: number | null;
    loans?: LoanDocument[] | null;
    companies?: CompanyDocument[] | null;
    cases?: CaseDocument[] | null;
};
/**
 * New standalone loan calculation
 */
export function postCalculationStandalone(standaloneRequest?: StandaloneRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CalculationInfoResponse;
    } | {
        status: 400;
        data: string;
    }>("/calculation/standalone", oazapfts.json({
        ...opts,
        method: "POST",
        body: standaloneRequest
    })));
}
/**
 * Get a freshly calculated interestsheet.
 */
export function getCalculationInterestsheet(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: InterestSheetResponse;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    }>("/calculation/interestsheet", {
        ...opts
    }));
}
/**
 * Get a budget model
 */
export function getCalculationBudget({ subsidizedLoan }: {
    subsidizedLoan?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    }>(`/calculation/budget${QS.query(QS.explode({
        subsidizedLoan
    }))}`, {
        ...opts
    }));
}
/**
 * Returns company info for user's cvr context.
 */
export function getCompany(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyInfoResponse;
    } | {
        status: 401;
    }>("/company", {
        ...opts
    }));
}
/**
 * Returns company guarantors/partnership liabilities for user's cvr context.
 */
export function getCompanyGuarantors(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyGuarantor[];
    } | {
        status: 204;
    } | {
        status: 401;
    }>("/company/guarantors", {
        ...opts
    }));
}
/**
 * Get the current bylaw document meta data.
 */
export function getCompanyCurrentbylaw(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: WzDocumentInfo;
    } | {
        status: 204;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/company/currentbylaw", {
        ...opts
    }));
}
/**
 * Gets the current by law pdf.
 */
export function getCompanyCurrentbylawPdf(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 204;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/company/currentbylaw/pdf", {
        ...opts
    }));
}
/**
 * Returns application configuration for MitKommuneKredit.
 */
export function getConfig(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: MitKkFrontEndApplicationConfig;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/config", {
        ...opts
    }));
}
/**
 * Returns document status for a given document.
 */
export function getDocumentsByDocumentIdStatus(documentId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentStatus;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 404;
        data: string;
    }>(`/documents/${encodeURIComponent(documentId)}/status`, {
        ...opts
    }));
}
/**
 * Get all documents for the user from kkSigning. Apply optional filter to filter on the signing status of the documents. retunrs a list of own documents and a list of guarantor related documents
 */
export function getDocuments({ filter }: {
    filter?: DocumentStatusFilter;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AllDocumentInfos;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 503;
        data: DocumentDatesError;
    }>(`/documents${QS.query(QS.explode({
        filter
    }))}`, {
        ...opts
    }));
}
/**
 * Gets basic information of a given document.
 */
export function getDocumentsByDocumentIdDocumentinfo(documentId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentInfo;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 404;
        data: string;
    }>(`/documents/${encodeURIComponent(documentId)}/documentinfo`, {
        ...opts
    }));
}
/**
 * Gets the pdf content of the unsigned document.
 */
export function getDocumentsByDocumentIdPdf(documentId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 404;
        data: string;
    }>(`/documents/${encodeURIComponent(documentId)}/pdf`, {
        ...opts
    }));
}
/**
 * Gets the signed document in pdf (PADeS) content.
 */
export function getDocumentsByDocumentIdSignedpdf(documentId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 404;
        data: string;
    }>(`/documents/${encodeURIComponent(documentId)}/signedpdf`, {
        ...opts
    }));
}
/**
 * Gets the bylaw pdf document using kkIdentity documentId
 */
export function getDocumentsByDocumentIdBylawpdf(documentId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 404;
        data: string;
    }>(`/documents/${encodeURIComponent(documentId)}/bylawpdf`, {
        ...opts
    }));
}
/**
 * Gets the number of pending documents to be signed for the user.
 */
export function getDocumentsPendingdocumentscount(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: number;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/documents/pendingdocumentscount", {
        ...opts
    }));
}
/**
 * Gets the signers for a given document.
 */
export function getDocumentsByDocumentIdSigners(documentId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: DocumentSignersResponse;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 404;
        data: string;
    }>(`/documents/${encodeURIComponent(documentId)}/signers`, {
        ...opts
    }));
}
/**
 * Gets the required iFrame for signing a given document. When the signing is completed, a POST-request from the iFrame is made to a validate endpoint, which redirects the user back to the frontend. Requires: Tegningsberettiget
 */
export function getDocumentsByDocumentIdSign(documentId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SignModel;
    } | {
        status: 204;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 404;
        data: ProblemDetails;
    } | {
        status: 500;
        data: string;
    }>(`/documents/${encodeURIComponent(documentId)}/sign`, {
        ...opts
    }));
}
/**
 * Validates a document signing jwt token. Requires: Tegningsberettiget
 */
export function postDocumentsValidate(body?: {
    result?: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 302;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/documents/validate", oazapfts.multipart({
        ...opts,
        method: "POST",
        body
    })));
}
/**
 * Create loan portfolio document as Excel/CSV for company identified by users CVR.
 */
export function postDocumentsCreateloanportfoliodocumentExcel(relation: Relation, { filterDate }: {
    filterDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>(`/documents/createloanportfoliodocument/excel${QS.query(QS.explode({
        relation,
        filterDate
    }))}`, {
        ...opts,
        method: "POST"
    }));
}
/**
 * Create calculation document as PDF using DocuMotor.
 */
export function postDocumentsCreatecalculationdocumentPdf(createCalculationDocumentRequest?: CreateCalculationDocumentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/documents/createcalculationdocument/pdf", oazapfts.json({
        ...opts,
        method: "POST",
        body: createCalculationDocumentRequest
    })));
}
/**
 * Create calculation document as Excel (XLSX) through LoanPortal Orchestration.
 */
export function postDocumentsCreatecalculationdocumentExcel(createCalculationDocumentRequest?: CreateCalculationDocumentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/documents/createcalculationdocument/excel", oazapfts.json({
        ...opts,
        method: "POST",
        body: createCalculationDocumentRequest
    })));
}
/**
 * Create contract document as PDF using DocuMotor.
 */
export function postDocumentsCreatecontractdocumentPdf(createContractDocumentRequest?: CreateContractDocumentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/documents/createcontractdocument/pdf", oazapfts.json({
        ...opts,
        method: "POST",
        body: createContractDocumentRequest
    })));
}
/**
 * Create contract document as Excel/CSV using DocuMotor.
 */
export function postDocumentsCreatecontractdocumentExcel(createContractDocumentRequest?: CreateContractDocumentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/documents/createcontractdocument/excel", oazapfts.json({
        ...opts,
        method: "POST",
        body: createContractDocumentRequest
    })));
}
/**
 * Create multiple calculation documents in a ZIP archive using DocuMotor.
 */
export function postDocumentsCreatecalculationdocumentsZip(createCalculationDocumentsRequest?: CreateCalculationDocumentsRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/documents/createcalculationdocuments/zip", oazapfts.json({
        ...opts,
        method: "POST",
        body: createCalculationDocumentsRequest
    })));
}
/**
 * Download stored document by PathToStorage.
 */
export function getDocumentsDownloadstoreddocument(downloadStoredDocumentRequest?: DownloadStoredDocumentRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: Blob;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/documents/downloadstoreddocument", oazapfts.json({
        ...opts,
        body: downloadStoredDocumentRequest
    })));
}
/**
 * Get the logged-in user’s company’s annual reports.
 */
export function getEdrmsdocumentAnnualreports(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: WzDocumentInfo[];
    } | {
        status: 204;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/edrmsdocument/annualreports", {
        ...opts
    }));
}
/**
 * Gets the pdf document using EdrmsDocumentId
 */
export function getEdrmsdocumentByEdrmsDocumentIdPdf(edrmsDocumentId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 204;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>(`/edrmsdocument/${encodeURIComponent(edrmsDocumentId)}/pdf`, {
        ...opts
    }));
}
/**
 * Returns user info for the logged in user.
 */
export function getIdentityUser(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: UserDto;
    } | {
        status: 401;
        data: string;
    }>("/identity/user", {
        ...opts
    }));
}
/**
 * Returns roles for all users that has been assigned roles for the same chosen company context for the logged in user.
 */
export function getIdentityUsers(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CompanyUsers;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/identity/users", {
        ...opts
    }));
}
/**
 * Updates email for user.
 */
export function putIdentityEmail(setEmailRequest?: SetEmailRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 204;
    } | {
        status: 400;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    } | {
        status: 404;
        data: ProblemDetails;
    } | {
        status: 500;
    }>("/identity/email", oazapfts.json({
        ...opts,
        method: "PUT",
        body: setEmailRequest
    })));
}
/**
 * Returns remaining debt info for user's cvr context.
 */
export function getLoansDebtinfos(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: AllRemainingDebtInfos;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/loans/debtinfos", {
        ...opts
    }));
}
/**
 * Returns loan info for given contractid at loanpage
 */
export function getLoansLoanpageinfo(contractId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: LoanPageInfo;
    } | {
        status: 204;
    } | {
        status: 401;
        data: ProblemDetails;
    }>(`/loans/loanpageinfo${QS.query(QS.explode({
        contractId
    }))}`, {
        ...opts
    }));
}
/**
 * Returns credit info for given contractid at creditloanpage
 */
export function getLoansCreditloanpageinfo({ contractId }: {
    contractId?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: CreditLoanPageInfo;
    } | {
        status: 204;
    } | {
        status: 401;
        data: ProblemDetails;
    }>(`/loans/creditloanpageinfo${QS.query(QS.explode({
        contractID: contractId
    }))}`, {
        ...opts
    }));
}
/**
 * Retrieves agreement portfolio for customer using CVR from userContext
 */
export function getLoansCustomerPortfolio({ filterDate }: {
    filterDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: PortfolioInfoResponse;
    } | {
        status: 204;
    } | {
        status: 401;
        data: ProblemDetails;
    }>(`/loans/customer/portfolio${QS.query(QS.explode({
        filterDate
    }))}`, {
        ...opts
    }));
}
/**
 * Get the earlist valid filter date for customer page agreement overviews.
 */
export function getLoansCustomerEarliestvalidfilterdate(opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: string;
    } | {
        status: 401;
        data: ProblemDetails;
    }>("/loans/customer/earliestvalidfilterdate", {
        ...opts
    }));
}
export function getLoansGuarantorliabilityByContractId(contractId: string, { fromDate }: {
    fromDate?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: GuarantorLiability[];
    } | {
        status: 204;
    } | {
        status: 400;
        data: ValidationErrorResponse;
    } | {
        status: 401;
        data: ProblemDetails;
    }>(`/loans/guarantorliability/${encodeURIComponent(contractId)}${QS.query(QS.explode({
        fromDate
    }))}`, {
        ...opts
    }));
}
export function getSearch({ query, limit }: {
    query?: string;
    limit?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.ok(oazapfts.fetchJson<{
        status: 200;
        data: SearchResponse;
    } | {
        status: 401;
        data: ProblemDetails;
    }>(`/search${QS.query(QS.explode({
        query,
        limit
    }))}`, {
        ...opts
    }));
}
export enum PaymentFreqEnum {
    UnDefined = "UnDefined",
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M6 = "M6",
    M12 = "M12"
}
export enum ContractLoanTypeEnum {
    NurUdlan = "NUR_udl\u00E5n",
    UdlanModelB = "Udl\u00E5n_Model_B",
    KKvar = "KKvar",
    KKmax = "KKmax",
    KKbasis = "KKbasis",
    KKcibor = "KKcibor",
    KKcita = "KKcita",
    KKfast = "KKfast",
    K4Udlan = "K4_udl\u00E5n",
    AiKontant = "AI_kontant",
    Rentetilpasningslan = "Rentetilpasningsl\u00E5n",
    Indekslan = "Indeksl\u00E5n",
    Obligationslan = "Obligationsl\u00E5n",
    AiLan = "AI_l\u00E5n",
    Swap = "Swap",
    Renteswap = "Renteswap",
    Valutaswap = "Valutaswap",
    ValutaTermin = "ValutaTermin",
    ValutaSpot = "ValutaSpot",
    KontantlaanAiKontant = "Kontantlaan_AI_kontant",
    KontantlaanK4Udlan = "Kontantlaan_K4_udl\u00E5n",
    Byggekredit = "Byggekredit",
    UnDefined = "UnDefined",
    Kkkur = "KKKUR"
}
export enum AmortizationProfile {
    Bullet = "Bullet",
    Annuity = "Annuity",
    Serial = "Serial",
    Custom = "Custom",
    UnDefined = "UnDefined"
}
export enum FixedInterestPeriodType {
    Cheapest = "Cheapest",
    ToMaturity = "ToMaturity",
    Years = "Years",
    UnDefined = "UnDefined"
}
export enum SustainableFrameworkType {
    Gbf2017 = "GBF2017",
    Gbf2022 = "GBF2022",
    None = "None"
}
export enum CurrencyCode {
    Dkk = "DKK",
    Eur = "EUR",
    Gbp = "GBP",
    Usd = "USD",
    Chf = "CHF",
    Undefined = "Undefined"
}
export enum InterestRateStatus {
    Fixed = "Fixed",
    Estimated = "Estimated",
    BeforeInterestConditionExpiryDate = "BeforeInterestConditionExpiryDate",
    AfterInterestConditionExpiryDate = "AfterInterestConditionExpiryDate"
}
export enum AdjustedUnadjustedEnum {
    Adjusted = "Adjusted",
    Unadjusted = "Unadjusted"
}
export enum DayCountConventions {
    Normal30360 = "NORMAL_30_360",
    A365Fix = "A365Fix",
    Act360 = "Act_360",
    A365Isd = "A365ISD",
    ActAct = "Act_Act",
    Belgian365365 = "BELGIAN_365_365",
    Euro30360 = "EURO_30_360",
    Us30360 = "US_30_360",
    Isda30360 = "ISDA_30_360",
    UnDefined = "UnDefined"
}
export enum PaymentAdviseTypes {
    Ean = "EAN",
    Bs = "BS",
    Pdf = "PDF"
}
export enum BusinessDayConventionEnum {
    Following = "Following",
    ModifiedFollowing = "ModifiedFollowing",
    Preceding = "Preceding"
}
export enum EventDescriptionCode {
    Conversion = "Conversion",
    FullRedemption = "FullRedemption",
    ExtraRepayment = "ExtraRepayment",
    NewLoan = "NewLoan",
    Redemption = "Redemption",
    NewInterestAgreement = "NewInterestAgreement"
}
export enum ChangeMethodCode {
    ReducedTimeToMaturity = "ReducedTimeToMaturity",
    ReducedPayment = "ReducedPayment",
    NewLoan = "NewLoan",
    RenewInterestAgreement = "RenewInterestAgreement"
}
export enum BudgetSecurity {
    Low = "Low",
    Medium = "Medium",
    High = "High",
    Undefined = "Undefined"
}
export enum ContractTypeEnum {
    UnDefined = "UnDefined",
    AndreIndlan = "Andre_indl\u00E5n",
    SlettedeKontrakter = "Slettede_kontrakter",
    KassekreditUdlan = "Kassekredit_udl\u00E5n",
    Valutahandel = "Valutahandel",
    OblUdstedelser = "Obl_udstedelser",
    SumSwap = "SUM_swap",
    InternLikviditet = "Intern_likviditet",
    EkInvestering = "EK_Investering",
    KobSwap = "KOB_swap",
    RenteSwap = "Rente_Swap",
    ValutaSwap = "Valuta_Swap",
    Obligationslan = "Obligationsl\u00E5n",
    Kontantlan = "Kontantl\u00E5n",
    Mismatch = "Mismatch",
    UdstedelserMismatch = "Udstedelser_Mismatch",
    Aftalelan = "Aftalel\u00E5n",
    Optioner = "Optioner"
}
export enum SubContractTypeEnum {
    Forpl = "Forpl",
    Deposit = "Deposit",
    Tilgodeh = "Tilgodeh",
    Lending = "Lending",
    Valutakob = "Valutak\u00F8b",
    Valutasalg = "Valutasalg"
}
export enum SubContractFixingTypeEnum {
    Fixed = "Fixed",
    Floating = "Floating",
    UnDefined = "UnDefined"
}
export enum InterestConvensionEnum {
    ThirtyThreeSixty = "ThirtyThreeSixty",
    ActAct = "ActAct",
    ActThreeSixty = "ActThreeSixty",
    ActThreeSixtyFive = "ActThreeSixtyFive",
    ThirtyThreeSixtyFive = "ThirtyThreeSixtyFive"
}
export enum ModificationStateEnum {
    Original = "Original",
    New = "New",
    Update = "Update",
    Delete = "Delete"
}
export enum InterestDetailedPaymentType {
    ClearCompensation = "ClearCompensation",
    Repayment = "Repayment",
    ExtraordinaryRepayment = "ExtraordinaryRepayment",
    Margin = "Margin",
    AccruedMargin = "AccruedMargin",
    Principal = "Principal",
    AppreciationInterestAndMargin = "AppreciationInterestAndMargin",
    AdditionalChargeAndRebateMargin = "AdditionalChargeAndRebateMargin",
    CashLoanInterest = "CashLoanInterest",
    InterestAdjustmentsKkmax = "InterestAdjustmentsKKMAX",
    Interest = "Interest",
    AccruedInterest = "AccruedInterest",
    TechnicalRepayment = "TechnicalRepayment",
    TechnicalPrincipal = "TechnicalPrincipal",
    AppreciationInterest = "AppreciationInterest",
    AppreciationMargin = "AppreciationMargin",
    AccruedAdditionalChargeAndRebateMargin = "AccruedAdditionalChargeAndRebateMargin",
    Undecided = "Undecided"
}
export enum ContractGroupEnum {
    UnDefined = "UnDefined",
    OblIndlan = "Obl_Indl\u00E5n",
    SamlingKontrakter = "Samling_kontrakter",
    MtnUdstedelserCall = "MTN_udstedelser_Call",
    System25 = "System_25",
    KKmax = "KKmax",
    NominalKonvInd = "Nominal_konv_ind",
    NominalInkonvInd = "Nominal_inkonv_ind",
    DanskePapirer = "Danske_papirer",
    OmxIndlanMm = "OMX_Indl\u00E5n_MM",
    AiLan = "AI_l\u00E5n",
    AiKontant = "AI_kontant",
    IsKontant = "IS_kontant",
    IsIndlan = "IS_indl\u00E5n",
    Kundeswaps = "Kundeswaps",
    KassekreditKur = "Kassekredit_KUR",
    Swaps = "Swaps",
    SumSwap = "SUM_swap",
    InternLikviditet = "Intern_likviditet",
    System24 = "System_24",
    System24Udtraekning = "System_24_udtr\u00E6kning",
    K4Indlan = "K4_indl\u00E5n",
    K4Udlan = "K4_udl\u00E5n",
    System25Udtraekning = "System_25_udtr\u00E6kning",
    KobSwap = "KOB_swap",
    System1 = "System_1",
    System2Udtraekning = "System_2_udtr\u00E6kning",
    System21Udtraekning = "System_21_udtr\u00E6kning",
    KobtCap = "K\u00F8bt_CAP",
    AiIndlan = "AI_indl\u00E5n",
    OvrigePapirer = "\u00D8vrige_papirer",
    OblUdlan = "Obl_Udl\u00E5n",
    Fondskode = "Fondskode",
    Udlan = "Udl\u00E5n",
    RtUdlan = "RT_udl\u00E5n",
    MtnUdstedelser = "MTN_udstedelser",
    EquityIndexedSwaps = "Equity_Indexed_Swaps",
    System2 = "System_2",
    System22Udtraekning = "System_22_udtr\u00E6kning",
    System1Udtraekning = "System_1_udtr\u00E6kning",
    CsaBond = "CSA_BOND",
    UdlanModelA = "Udl\u00E5n_Model_A",
    PrivatePlacements = "Private_Placements",
    UdlanModelC = "Udl\u00E5n_Model_C",
    SwapCallable = "Swap_Callable",
    System21 = "System_21",
    System22 = "System_22",
    KKbasis = "KKbasis",
    DanskeMedUdtraek = "Danske_med_udtr\u00E6k",
    RtIndlan = "RT_indl\u00E5n",
    FxSwap = "FX_swap",
    Valutatermin = "Valutatermin",
    Valutaspot = "Valutaspot"
}
export enum ContractStatus {
    NotYetActive = "NotYetActive",
    Active = "Active",
    Archived = "Archived"
}
export enum RedemptionCalculationMethod {
    Normal = "Normal",
    None = "None"
}
export enum InterestReferenceIdEnum {
    Credit = "Credit",
    UnDefined = "UnDefined"
}
export enum IdpTypes {
    MitIdPrivat = "MitIdPrivat",
    MitIdErhverv = "MitIdErhverv"
}
export enum DocumentStatusFilter {
    All = "All",
    Active = "Active",
    Inactive = "Inactive"
}
export enum DocumentSigningRelation {
    Company = "Company",
    Guarantor = "Guarantor"
}
export enum DocumentType {
    LoanDocument = "LoanDocument",
    PowerOfAttorney = "PowerOfAttorney",
    AllongeToPromissoryNote = "AllongeToPromissoryNote"
}
export enum Relation {
    Owner = "Owner",
    Guarantee = "Guarantee",
    PartnershipLiability = "PartnershipLiability",
    BillReceiver = "BillReceiver",
    Undefined = "Undefined"
}
export enum FileExtensionEnum {
    Pdf = "Pdf",
    Csv = "Csv",
    Zip = "Zip"
}
export enum Roles {
    AuthorizedToSign = "AuthorizedToSign",
    Access = "Access"
}
export enum LoanCategory {
    ContractLoan = "ContractLoan",
    ConstructionCredit = "ConstructionCredit",
    BondLoan = "BondLoan",
    SubsidizedLoan = "SubsidizedLoan",
    Swap = "Swap",
    Undefined = "Undefined"
}
export enum InterestType {
    Fixed = "Fixed",
    Floating = "Floating",
    Undefined = "Undefined"
}
export enum LiabilityType {
    Undefined = "Undefined",
    ProRata = "ProRata",
    Solidarity = "Solidarity"
}
export enum GuaranteeRelations {
    GuarantorAlone = "GuarantorAlone",
    GuarantorProRata = "GuarantorProRata",
    StakeHolderGuaranteeProRata = "StakeHolderGuaranteeProRata",
    GuarantorInSolidarity = "GuarantorInSolidarity",
    StakeHolderGuarantee = "StakeHolderGuarantee"
}

// #region INJECTED PATHS
/* The generated output is not a direct result of oazapfts' default behavior.
* It instead incorporates our custom code, which adds path placeholder properties for MSW mocking, into the output of oazapfts. */
// {{{

const _postCalculationStandalonePath = () => defaults.baseUrl + '/calculation/standalone';
Object.defineProperty(postCalculationStandalone, 'path', { get: _postCalculationStandalonePath, set: _postCalculationStandalonePath });
/** @path `/calculation/standalone` */ 
postCalculationStandalone.path = postCalculationStandalone.path satisfies string;


const _getCalculationInterestsheetPath = () => defaults.baseUrl + '/calculation/interestsheet';
Object.defineProperty(getCalculationInterestsheet, 'path', { get: _getCalculationInterestsheetPath, set: _getCalculationInterestsheetPath });
/** @path `/calculation/interestsheet` */ 
getCalculationInterestsheet.path = getCalculationInterestsheet.path satisfies string;


const _getCalculationBudgetPath = () => defaults.baseUrl + '/calculation/budget';
Object.defineProperty(getCalculationBudget, 'path', { get: _getCalculationBudgetPath, set: _getCalculationBudgetPath });
/** @path `/calculation/budget` */ 
getCalculationBudget.path = getCalculationBudget.path satisfies string;


const _getCompanyPath = () => defaults.baseUrl + '/company';
Object.defineProperty(getCompany, 'path', { get: _getCompanyPath, set: _getCompanyPath });
/** @path `/company` */ 
getCompany.path = getCompany.path satisfies string;


const _getCompanyGuarantorsPath = () => defaults.baseUrl + '/company/guarantors';
Object.defineProperty(getCompanyGuarantors, 'path', { get: _getCompanyGuarantorsPath, set: _getCompanyGuarantorsPath });
/** @path `/company/guarantors` */ 
getCompanyGuarantors.path = getCompanyGuarantors.path satisfies string;


const _getCompanyCurrentbylawPath = () => defaults.baseUrl + '/company/currentbylaw';
Object.defineProperty(getCompanyCurrentbylaw, 'path', { get: _getCompanyCurrentbylawPath, set: _getCompanyCurrentbylawPath });
/** @path `/company/currentbylaw` */ 
getCompanyCurrentbylaw.path = getCompanyCurrentbylaw.path satisfies string;


const _getCompanyCurrentbylawPdfPath = () => defaults.baseUrl + '/company/currentbylaw/pdf';
Object.defineProperty(getCompanyCurrentbylawPdf, 'path', { get: _getCompanyCurrentbylawPdfPath, set: _getCompanyCurrentbylawPdfPath });
/** @path `/company/currentbylaw/pdf` */ 
getCompanyCurrentbylawPdf.path = getCompanyCurrentbylawPdf.path satisfies string;


const _getConfigPath = () => defaults.baseUrl + '/config';
Object.defineProperty(getConfig, 'path', { get: _getConfigPath, set: _getConfigPath });
/** @path `/config` */ 
getConfig.path = getConfig.path satisfies string;


const _getDocumentsByDocumentIdStatusPath = () => defaults.baseUrl + '/documents/:documentId/status';
Object.defineProperty(getDocumentsByDocumentIdStatus, 'path', { get: _getDocumentsByDocumentIdStatusPath, set: _getDocumentsByDocumentIdStatusPath });
/** @path `/documents/:documentId/status` */ 
getDocumentsByDocumentIdStatus.path = getDocumentsByDocumentIdStatus.path satisfies string;


const _getDocumentsPath = () => defaults.baseUrl + '/documents';
Object.defineProperty(getDocuments, 'path', { get: _getDocumentsPath, set: _getDocumentsPath });
/** @path `/documents` */ 
getDocuments.path = getDocuments.path satisfies string;


const _getDocumentsByDocumentIdDocumentinfoPath = () => defaults.baseUrl + '/documents/:documentId/documentinfo';
Object.defineProperty(getDocumentsByDocumentIdDocumentinfo, 'path', { get: _getDocumentsByDocumentIdDocumentinfoPath, set: _getDocumentsByDocumentIdDocumentinfoPath });
/** @path `/documents/:documentId/documentinfo` */ 
getDocumentsByDocumentIdDocumentinfo.path = getDocumentsByDocumentIdDocumentinfo.path satisfies string;


const _getDocumentsByDocumentIdPdfPath = () => defaults.baseUrl + '/documents/:documentId/pdf';
Object.defineProperty(getDocumentsByDocumentIdPdf, 'path', { get: _getDocumentsByDocumentIdPdfPath, set: _getDocumentsByDocumentIdPdfPath });
/** @path `/documents/:documentId/pdf` */ 
getDocumentsByDocumentIdPdf.path = getDocumentsByDocumentIdPdf.path satisfies string;


const _getDocumentsByDocumentIdSignedpdfPath = () => defaults.baseUrl + '/documents/:documentId/signedpdf';
Object.defineProperty(getDocumentsByDocumentIdSignedpdf, 'path', { get: _getDocumentsByDocumentIdSignedpdfPath, set: _getDocumentsByDocumentIdSignedpdfPath });
/** @path `/documents/:documentId/signedpdf` */ 
getDocumentsByDocumentIdSignedpdf.path = getDocumentsByDocumentIdSignedpdf.path satisfies string;


const _getDocumentsByDocumentIdBylawpdfPath = () => defaults.baseUrl + '/documents/:documentId/bylawpdf';
Object.defineProperty(getDocumentsByDocumentIdBylawpdf, 'path', { get: _getDocumentsByDocumentIdBylawpdfPath, set: _getDocumentsByDocumentIdBylawpdfPath });
/** @path `/documents/:documentId/bylawpdf` */ 
getDocumentsByDocumentIdBylawpdf.path = getDocumentsByDocumentIdBylawpdf.path satisfies string;


const _getDocumentsPendingdocumentscountPath = () => defaults.baseUrl + '/documents/pendingdocumentscount';
Object.defineProperty(getDocumentsPendingdocumentscount, 'path', { get: _getDocumentsPendingdocumentscountPath, set: _getDocumentsPendingdocumentscountPath });
/** @path `/documents/pendingdocumentscount` */ 
getDocumentsPendingdocumentscount.path = getDocumentsPendingdocumentscount.path satisfies string;


const _getDocumentsByDocumentIdSignersPath = () => defaults.baseUrl + '/documents/:documentId/signers';
Object.defineProperty(getDocumentsByDocumentIdSigners, 'path', { get: _getDocumentsByDocumentIdSignersPath, set: _getDocumentsByDocumentIdSignersPath });
/** @path `/documents/:documentId/signers` */ 
getDocumentsByDocumentIdSigners.path = getDocumentsByDocumentIdSigners.path satisfies string;


const _getDocumentsByDocumentIdSignPath = () => defaults.baseUrl + '/documents/:documentId/sign';
Object.defineProperty(getDocumentsByDocumentIdSign, 'path', { get: _getDocumentsByDocumentIdSignPath, set: _getDocumentsByDocumentIdSignPath });
/** @path `/documents/:documentId/sign` */ 
getDocumentsByDocumentIdSign.path = getDocumentsByDocumentIdSign.path satisfies string;


const _postDocumentsValidatePath = () => defaults.baseUrl + '/documents/validate';
Object.defineProperty(postDocumentsValidate, 'path', { get: _postDocumentsValidatePath, set: _postDocumentsValidatePath });
/** @path `/documents/validate` */ 
postDocumentsValidate.path = postDocumentsValidate.path satisfies string;


const _postDocumentsCreateloanportfoliodocumentExcelPath = () => defaults.baseUrl + '/documents/createloanportfoliodocument/excel';
Object.defineProperty(postDocumentsCreateloanportfoliodocumentExcel, 'path', { get: _postDocumentsCreateloanportfoliodocumentExcelPath, set: _postDocumentsCreateloanportfoliodocumentExcelPath });
/** @path `/documents/createloanportfoliodocument/excel` */ 
postDocumentsCreateloanportfoliodocumentExcel.path = postDocumentsCreateloanportfoliodocumentExcel.path satisfies string;


const _postDocumentsCreatecalculationdocumentPdfPath = () => defaults.baseUrl + '/documents/createcalculationdocument/pdf';
Object.defineProperty(postDocumentsCreatecalculationdocumentPdf, 'path', { get: _postDocumentsCreatecalculationdocumentPdfPath, set: _postDocumentsCreatecalculationdocumentPdfPath });
/** @path `/documents/createcalculationdocument/pdf` */ 
postDocumentsCreatecalculationdocumentPdf.path = postDocumentsCreatecalculationdocumentPdf.path satisfies string;


const _postDocumentsCreatecalculationdocumentExcelPath = () => defaults.baseUrl + '/documents/createcalculationdocument/excel';
Object.defineProperty(postDocumentsCreatecalculationdocumentExcel, 'path', { get: _postDocumentsCreatecalculationdocumentExcelPath, set: _postDocumentsCreatecalculationdocumentExcelPath });
/** @path `/documents/createcalculationdocument/excel` */ 
postDocumentsCreatecalculationdocumentExcel.path = postDocumentsCreatecalculationdocumentExcel.path satisfies string;


const _postDocumentsCreatecontractdocumentPdfPath = () => defaults.baseUrl + '/documents/createcontractdocument/pdf';
Object.defineProperty(postDocumentsCreatecontractdocumentPdf, 'path', { get: _postDocumentsCreatecontractdocumentPdfPath, set: _postDocumentsCreatecontractdocumentPdfPath });
/** @path `/documents/createcontractdocument/pdf` */ 
postDocumentsCreatecontractdocumentPdf.path = postDocumentsCreatecontractdocumentPdf.path satisfies string;


const _postDocumentsCreatecontractdocumentExcelPath = () => defaults.baseUrl + '/documents/createcontractdocument/excel';
Object.defineProperty(postDocumentsCreatecontractdocumentExcel, 'path', { get: _postDocumentsCreatecontractdocumentExcelPath, set: _postDocumentsCreatecontractdocumentExcelPath });
/** @path `/documents/createcontractdocument/excel` */ 
postDocumentsCreatecontractdocumentExcel.path = postDocumentsCreatecontractdocumentExcel.path satisfies string;


const _postDocumentsCreatecalculationdocumentsZipPath = () => defaults.baseUrl + '/documents/createcalculationdocuments/zip';
Object.defineProperty(postDocumentsCreatecalculationdocumentsZip, 'path', { get: _postDocumentsCreatecalculationdocumentsZipPath, set: _postDocumentsCreatecalculationdocumentsZipPath });
/** @path `/documents/createcalculationdocuments/zip` */ 
postDocumentsCreatecalculationdocumentsZip.path = postDocumentsCreatecalculationdocumentsZip.path satisfies string;


const _getDocumentsDownloadstoreddocumentPath = () => defaults.baseUrl + '/documents/downloadstoreddocument';
Object.defineProperty(getDocumentsDownloadstoreddocument, 'path', { get: _getDocumentsDownloadstoreddocumentPath, set: _getDocumentsDownloadstoreddocumentPath });
/** @path `/documents/downloadstoreddocument` */ 
getDocumentsDownloadstoreddocument.path = getDocumentsDownloadstoreddocument.path satisfies string;


const _getEdrmsdocumentAnnualreportsPath = () => defaults.baseUrl + '/edrmsdocument/annualreports';
Object.defineProperty(getEdrmsdocumentAnnualreports, 'path', { get: _getEdrmsdocumentAnnualreportsPath, set: _getEdrmsdocumentAnnualreportsPath });
/** @path `/edrmsdocument/annualreports` */ 
getEdrmsdocumentAnnualreports.path = getEdrmsdocumentAnnualreports.path satisfies string;


const _getEdrmsdocumentByEdrmsDocumentIdPdfPath = () => defaults.baseUrl + '/edrmsdocument/:edrmsDocumentId/pdf';
Object.defineProperty(getEdrmsdocumentByEdrmsDocumentIdPdf, 'path', { get: _getEdrmsdocumentByEdrmsDocumentIdPdfPath, set: _getEdrmsdocumentByEdrmsDocumentIdPdfPath });
/** @path `/edrmsdocument/:edrmsDocumentId/pdf` */ 
getEdrmsdocumentByEdrmsDocumentIdPdf.path = getEdrmsdocumentByEdrmsDocumentIdPdf.path satisfies string;


const _getIdentityUserPath = () => defaults.baseUrl + '/identity/user';
Object.defineProperty(getIdentityUser, 'path', { get: _getIdentityUserPath, set: _getIdentityUserPath });
/** @path `/identity/user` */ 
getIdentityUser.path = getIdentityUser.path satisfies string;


const _getIdentityUsersPath = () => defaults.baseUrl + '/identity/users';
Object.defineProperty(getIdentityUsers, 'path', { get: _getIdentityUsersPath, set: _getIdentityUsersPath });
/** @path `/identity/users` */ 
getIdentityUsers.path = getIdentityUsers.path satisfies string;


const _putIdentityEmailPath = () => defaults.baseUrl + '/identity/email';
Object.defineProperty(putIdentityEmail, 'path', { get: _putIdentityEmailPath, set: _putIdentityEmailPath });
/** @path `/identity/email` */ 
putIdentityEmail.path = putIdentityEmail.path satisfies string;


const _getLoansDebtinfosPath = () => defaults.baseUrl + '/loans/debtinfos';
Object.defineProperty(getLoansDebtinfos, 'path', { get: _getLoansDebtinfosPath, set: _getLoansDebtinfosPath });
/** @path `/loans/debtinfos` */ 
getLoansDebtinfos.path = getLoansDebtinfos.path satisfies string;


const _getLoansLoanpageinfoPath = () => defaults.baseUrl + '/loans/loanpageinfo';
Object.defineProperty(getLoansLoanpageinfo, 'path', { get: _getLoansLoanpageinfoPath, set: _getLoansLoanpageinfoPath });
/** @path `/loans/loanpageinfo` */ 
getLoansLoanpageinfo.path = getLoansLoanpageinfo.path satisfies string;


const _getLoansCreditloanpageinfoPath = () => defaults.baseUrl + '/loans/creditloanpageinfo';
Object.defineProperty(getLoansCreditloanpageinfo, 'path', { get: _getLoansCreditloanpageinfoPath, set: _getLoansCreditloanpageinfoPath });
/** @path `/loans/creditloanpageinfo` */ 
getLoansCreditloanpageinfo.path = getLoansCreditloanpageinfo.path satisfies string;


const _getLoansCustomerPortfolioPath = () => defaults.baseUrl + '/loans/customer/portfolio';
Object.defineProperty(getLoansCustomerPortfolio, 'path', { get: _getLoansCustomerPortfolioPath, set: _getLoansCustomerPortfolioPath });
/** @path `/loans/customer/portfolio` */ 
getLoansCustomerPortfolio.path = getLoansCustomerPortfolio.path satisfies string;


const _getLoansCustomerEarliestvalidfilterdatePath = () => defaults.baseUrl + '/loans/customer/earliestvalidfilterdate';
Object.defineProperty(getLoansCustomerEarliestvalidfilterdate, 'path', { get: _getLoansCustomerEarliestvalidfilterdatePath, set: _getLoansCustomerEarliestvalidfilterdatePath });
/** @path `/loans/customer/earliestvalidfilterdate` */ 
getLoansCustomerEarliestvalidfilterdate.path = getLoansCustomerEarliestvalidfilterdate.path satisfies string;


const _getLoansGuarantorliabilityByContractIdPath = () => defaults.baseUrl + '/loans/guarantorliability/:contractId';
Object.defineProperty(getLoansGuarantorliabilityByContractId, 'path', { get: _getLoansGuarantorliabilityByContractIdPath, set: _getLoansGuarantorliabilityByContractIdPath });
/** @path `/loans/guarantorliability/:contractId` */ 
getLoansGuarantorliabilityByContractId.path = getLoansGuarantorliabilityByContractId.path satisfies string;


const _getSearchPath = () => defaults.baseUrl + '/search';
Object.defineProperty(getSearch, 'path', { get: _getSearchPath, set: _getSearchPath });
/** @path `/search` */ 
getSearch.path = getSearch.path satisfies string;


// }}}
 // #endregion 